module.exports = __webpack_public_path__ + "img/IMG_2511-2.64a30193.jpg";